import Lenis from 'lenis';
import { isLenisActive } from './lib/lenisConditions';

export const lenis = isLenisActive()
  ? new Lenis({
    lerp: 0.075,
    smoothWheel: true,
    anchors: {
      offset: -100,
    },
    prevent: (node) => node.classList.contains('ts-dropdown-content'), // tomselect dropdown
  })
  : {
    on: () => { },
    off: () => { },
    raf: () => { },
    start: () => { },
    stop: () => { },
    destroy: () => { },
  };

// breakpoints
export const xs = 320;
export const sm = 450;
export const md = 768;
export const lg = 1024;
export const xl = 1400;
export const xl2 = 1900;
export const wide = 2500;
export const xwide = 3800;
